import { Component, input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { tablerLoader2 } from '@ng-icons/tabler-icons';

@Component({
  selector: 'loader',
  template: `<ng-icon name="tablerLoader2" [size]="size()" [style.color]="color()" />`,
  styles: `
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    ng-icon {
      animation: spin 1s linear infinite;
      color: var(--adb-blue);
    }

    :host {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `,
  imports: [NgIcon],
  providers: [provideIcons({ tablerLoader2 })],
})
export class Loader {
  size = input<string>('32px');
  color = input<string>();
}
